import { connect } from 'react-redux';

import { selectors } from 'dux/createInstance';
import { actionCreators as clickTrackerActionCreators } from 'dux/clickTracker';
import StepTwo from './StepTwo';

function mapStateToProps(state) {
  return {
    availableFlavors: selectors.availableFlavorsSelector(state),
    availableAddons: selectors.availableAddonsSelector(state),
    availablePlans: selectors.availablePlansSelector(state),
    selectedPlan: selectors.selectedPlanSelector(state),
    selectedFlavor: selectors.selectedFlavorSelector(state),
    selectedService: selectors.selectedServiceSelector(state),
    nodeInfoString: selectors.nodeInfoStringSelector(state),
    addonInfoString: selectors.addonInfoStringSelector(state),
  };
}

const mapDispatchToProps = {
  trackButtonClick: clickTrackerActionCreators.trackButtonClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(StepTwo);
